(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
  /*
   * Turns through the lines that apply and swaps in fresh ones when the bag
   * changes. Liquid decides what the lines say; this only chooses which one shows.
   */
  class AnnouncementBar extends HTMLElement {
    connectedCallback() {
      // Every listener goes through one signal, so the theme editor re-rendering or
      // moving the section leaves no timer or listener behind, and none doubled up.
      this.disconnectedCallback();
      this.abort = new AbortController();
      const on = (target, type, fn) => target.addEventListener(type, fn, { signal: this.abort.signal });

      this.live = this.querySelector('[data-live]');
      this.quiet = matchMedia('(prefers-reduced-motion: reduce)').matches;
      // Every reason it is holding still; it turns only when there are none.
      this.holds = new Set();
      this.index = 0;

      on(this, 'pointerenter', () => this.hold('hover', true));
      on(this, 'pointerleave', () => this.hold('hover', false));
      // Reading a link or using the language switcher holds it.
      on(this, 'focusin', () => this.hold('focus', true));
      on(this, 'focusout', (event) => !this.contains(event.relatedTarget) && this.hold('focus', false));
      this.away = new IntersectionObserver(([entry]) => this.hold('away', !entry.isIntersecting));
      this.away.observe(this);
      on(document, 'visibilitychange', () => this.hold('hidden', document.hidden));

      // A change is announced; a page the back button restored only catches up with its bag
      // (assets/cart-add.js re-reads it, `restored`): nothing was just added to celebrate.
      on(document, 'cart:updated', (event) =>
        this.refresh(event.detail?.sections?.[this.dataset.cartSection], !event.detail?.restored, event.detail)
      );
      // That page kept its old pointer state too.
      on(window, 'pageshow', (event) => event.persisted && this.hold('hover', this.matches(':hover')));

      // The theme editor: selecting a line shows it, whatever its condition, until deselected.
      on(this, 'shopify:block:select', (event) => {
        this.hold('editor', true);
        this.querySelectorAll('[data-line]').forEach((line) => line.classList.toggle('is-active', line === event.target));
      });
      on(this, 'shopify:block:deselect', () => {
        this.hold('editor', false);
        this.show(this.index);
      });

      // The bar is right at first paint without any script, so the timer waits for
      // the first idle moment instead of competing with the page as it loads. Not
      // for the load event: third-party scripts held that off for over 26s on a slow phone.
      const idle = window.requestIdleCallback || ((fn) => setTimeout(fn, 200));
      idle(() => this.isConnected && this.start(), { timeout: 3000 });
    }

    disconnectedCallback() {
      this.abort?.abort();
      this.away?.disconnect();
      clearInterval(this.timer);
      clearTimeout(this.colour);
      clearTimeout(this.linger);
    }

    lines() {
      return [...this.querySelectorAll('[data-line]:not([data-off])')];
    }

    hold(reason, on) {
      if (on) this.holds.add(reason);
      else this.holds.delete(reason);
    }

    start() {
      const lines = this.lines();
      this.index = Math.max(0, lines.findIndex((line) => line.classList.contains('is-active')));
      const turning = !this.quiet && lines.length > 1;
      clearInterval(this.timer);
      if (turning) this.timer = setInterval(() => this.holds.size || this.show(this.index + 1), Number(this.dataset.dwell) || 5000);
    }

    show(n) {
      const lines = this.lines();
      if (!lines.length) return;
      this.index = (n + lines.length) % lines.length;
      this.querySelectorAll('[data-line]').forEach((line) => line.classList.toggle('is-active', line === lines[this.index]));
    }

    // Swap in the lines Shopify re-rendered for the new bag, and turn to the
    // free-delivery line: after an add, it is the one the shopper wants.
    refresh(html, announce, detail) {
      if (typeof html !== 'string') return;
      const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('announcement-bar');
      // Nothing left to say for this bag: the bar goes, rather than keep an old line up.
      this.hidden = !fresh;
      if (!fresh) return;
      const was = this.querySelector('[data-progress]')?.dataset.progress;
      this.querySelector('[data-lines]').replaceWith(fresh.querySelector('[data-lines]'));
      // A link that had focus may have just been replaced.
      this.hold('focus', this.contains(document.activeElement));
      this.start();
      const progress = this.lines().findIndex((line) => line.hasAttribute('data-progress'));
      if (progress < 0) return;
      this.show(progress);
      if (!announce) return;
      this.live.textContent = this.lines()[progress].textContent.trim();
      if (was !== 'done' && this.lines()[progress].dataset.progress === 'done') this.unlocked(detail);
    }

    // The add that reached free delivery. The bar turns Royale Blue for three seconds
    // and keeps the line up for ten; the button that was pressed says it too (cart-add.js
    // reads detail.note), because the bar has usually scrolled out of sight by then.
    unlocked(detail) {
      if (detail) detail.note = this.dataset.note;
      clearTimeout(this.colour);
      clearTimeout(this.linger);
      this.classList.add('is-unlocked');
      this.hold('moment', true);
      this.colour = setTimeout(() => this.classList.remove('is-unlocked'), 3000);
      this.linger = setTimeout(() => this.hold('moment', false), 10000);
    }
  }

  customElements.define('announcement-bar', AnnouncementBar);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  /*
   * The drawer: opens from Bag and after an add, closes on Escape, the dimmed page or
   * the arrow, and gives focus back. On /cart the bag is the page itself, so it stays
   * shut there and Bag is simply followed.
   */
  class CartDrawer extends HTMLElement {
    connectedCallback() {
      this.disconnectedCallback();
      this.abort = new AbortController();
      const { signal } = this.abort;
      this.dialog = this.querySelector('dialog');

      document.addEventListener(
        'click',
        (event) => {
          const opener = event.target.closest('[data-bag-open]');
          // A modified click still opens /cart in a new tab, as a link should.
          if (!opener || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          if (this.open(opener)) event.preventDefault();
        },
        { signal }
      );

      // After an add, unless Theme settings > Bag says otherwise.
      document.addEventListener(
        'cart:updated',
        (event) => event.detail?.added && this.dataset.openOnAdd === 'true' && this.open(event.detail.source),
        { signal }
      );

      // The arrow, and a click on the dimmed page, which lands on the dialog itself.
      this.dialog.addEventListener(
        'click',
        (event) => (event.target === this.dialog || event.target.closest('[data-bag-close]')) && this.dialog.close(),
        { signal }
      );

      this.dialog.addEventListener(
        'close',
        () => {
          const back = this.opener?.isConnected ? this.opener : document.getElementById('MainContent');
          back?.focus({ preventScroll: true });
          this.opener = null;
        },
        { signal }
      );
    }

    disconnectedCallback() {
      this.abort?.abort();
    }

    // False on /cart, where the bag is already the page and the link should be followed.
    open(opener) {
      if (document.querySelector('cart-bag[data-context="page"]')) return false;
      if (!this.dialog.open) {
        // Quick view or a story gives way to the bag.
        document.querySelectorAll('dialog[open]').forEach((other) => other.close());
        this.opener = opener || document.activeElement;
        this.dialog.showModal();
      }
      this.dialog.querySelector('[data-bag-close]')?.focus();
      return true;
    }
  }

  /*
   * The bag's controls, in the drawer and on /cart. Underneath they are form buttons
   * posting to /cart; this turns each into one request through assets/cart-add.js and
   * swaps in the bag Shopify re-renders in the reply.
   */
  class CartBag extends HTMLElement {
    connectedCallback() {
      this.disconnectedCallback();
      this.abort = new AbortController();
      const { signal } = this.abort;

      // Outside the part that gets replaced, so a screen reader hears the new total.
      if (!this.live) {
        this.live = document.createElement('span');
        this.live.className = 'visually-hidden';
        this.live.setAttribute('aria-live', 'polite');
        this.after(this.live);
      }

      // Every change, and a page the back button restored with its old bag (assets/cart-add.js re-reads it).
      document.addEventListener('cart:updated', (event) => this.refresh(event.detail?.sections?.[this.dataset.cartSection]), { signal });
      this.addEventListener('click', (event) => this.click(event), { signal });
      this.addEventListener('change', (event) => this.change(event), { signal });
      this.addEventListener(
        'keydown',
        (event) => {
          if (event.key !== 'Enter' || !event.target.matches('[data-bag-promo]')) return;
          event.preventDefault();
          this.apply();
        },
        { signal }
      );

      // Scroll does not bubble, so the fade is redrawn from the capture phase. Watching this
      // element catches the drawer opening, where the body goes from no height to its real one.
      this.addEventListener('scroll', () => this.edges(), { capture: true, passive: true, signal });
      this.watch = new ResizeObserver(() => this.edges());
      this.watch.observe(this);
    }

    disconnectedCallback() {
      this.abort?.abort();
      this.watch?.disconnect();
    }

    get form() {
      return this.querySelector('[data-bag]');
    }

    // Locale-aware, so Shopify answers in the shopper's language.
    get root() {
      return window.Shopify?.routes?.root || '/';
    }

    codes() {
      return (this.form?.dataset.codes || '').split(',').filter(Boolean);
    }

    click(event) {
      // Without the shared script the buttons stay plain form posts, which still work.
      if (!window.cartRequest) return;
      // The stepper and Remove: form buttons named updates[key], valued with the new quantity.
      const step = event.target.closest('button[name^="updates["]');
      if (step) {
        event.preventDefault();
        const key = step.name.slice(8, -1);
        const quantity = Number(step.value);
        const wrap = this.querySelector('[data-bag-wrap]:checked');
        // The last piece going takes the wrapping and its card with it: wrapping alone is not an order.
        if (quantity === 0 && wrap && this.querySelectorAll('.bag__line').length === 1) {
          this.send('cart/update.js', { updates: { [key]: 0, [wrap.dataset.bagWrap]: 0 }, note: '' }, step);
        } else {
          this.send('cart/change.js', { id: key, quantity }, step);
        }
        return;
      }
      if (event.target.closest('[data-bag-apply]')) {
        this.apply();
        return;
      }
      const drop = event.target.closest('[data-bag-unapply]');
      if (drop) {
        const gone = drop.dataset.bagUnapply.toLowerCase();
        this.recode((codes) => codes.filter((code) => code.toLowerCase() !== gone), drop);
      }
    }

    change(event) {
      const wrap = event.target.closest('[data-bag-wrap]');
      // Unwrapped, the card message goes too: a card with no gift is not what was asked for.
      if (wrap) {
        const updates = { [wrap.dataset.bagWrap]: wrap.checked ? 1 : 0 };
        this.send('cart/update.js', wrap.checked ? { updates } : { updates, note: '' }, wrap);
      }
      // The card message saves quietly -- re-rendering would throw away the caret -- and the
      // next change waits for it, so the bag never comes back with the old message.
      if (event.target.matches('[data-bag-note]')) {
        this.noting = fetch(`${this.root}cart/update.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ note: event.target.value }),
        }).catch(() => {});
      }
    }

    async apply() {
      const input = this.querySelector('[data-bag-promo]');
      const code = input?.value.trim();
      if (!code) return;
      const invalid = (this.form?.dataset.promoInvalid || '').replace('*', code);
      const detail = await this.recode((codes) => [...codes, code], input);
      if (!detail) return;
      // Shopify keeps a code it cannot use on this bag and marks it; say so rather than show nothing.
      const same = (other) => other.toLowerCase() === code.toLowerCase();
      const reported = (detail.cart?.discount_codes || []).find((entry) => same(entry.code));
      const used = reported ? reported.applicable : this.codes().some(same);
      if (!used) this.error(invalid);
    }

    // Shopify replaces the bag's whole list of codes with the one it is sent, and holds codes it
    // cannot use yet -- a /discount/ link under its minimum -- without their showing here. The
    // full list is read first, so adding or dropping one code never loses another.
    async recode(edit, control) {
      let codes = this.codes();
      try {
        const cart = await (await fetch(`${this.root}cart.js`)).json();
        if (cart.discount_codes) codes = cart.discount_codes.map((entry) => entry.code);
      } catch {
        // The codes the bag shows are the next best list.
      }
      return this.send('cart/update.js', { discount: edit(codes).join(',') }, control);
    }

    async send(url, body, control) {
      if (this.busy || !window.cartRequest) return null;
      this.busy = true;
      this.setAttribute('aria-busy', 'true');
      this.error('');
      this.memo = control ? this.hooks(control) : null;
      try {
        await this.noting;
        return await window.cartRequest(url, body, control);
      } catch (error) {
        this.error(error.message || this.form?.dataset.error || '');
        return null;
      } finally {
        this.busy = false;
        this.removeAttribute('aria-busy');
      }
    }

    error(message) {
      const box = this.querySelector('[data-bag-error]');
      if (!box) return;
      box.textContent = message;
      box.hidden = !message;
    }

    refresh(html) {
      const fresh =
        html && new DOMParser().parseFromString(html, 'text/html').querySelector(`cart-bag[data-cart-section="${this.dataset.cartSection}"]`);
      if (!fresh) return;
      // Focus inside the part about to be replaced would fall to the page: note it first.
      // An add opens the drawer with focus on its arrow, then this swaps the arrow out.
      const hadFocus = this.contains(document.activeElement);
      const was = this.querySelector('[data-bag-track]')?.style.getPropertyValue('--fill');
      this.replaceChildren(...fresh.childNodes);

      // The delivery bar travels from where it stood to where it stands now, rather than
      // appearing at the new length: the whole point of it is the movement.
      const track = this.querySelector('[data-bag-track]');
      if (track && was) {
        const now = track.style.getPropertyValue('--fill');
        track.style.setProperty('--fill', was);
        track.getBoundingClientRect();
        track.style.setProperty('--fill', now);
      }
      const total = this.querySelector('.bag__sum--total') || this.querySelector('.bag__empty-text');
      this.live.textContent = total ? total.textContent.replace(/\s+/g, ' ').trim() : '';
      this.edges();

      // Keep the shopper's place: the same control, else a safe one -- never another line's
      // buttons, where one more press would change a piece they did not touch.
      const hooks = this.memo;
      this.memo = null;
      if (!hooks && !hadFocus) return;
      const next = [...(hooks || []), '[data-bag-close]', '.bag__checkout', '.bag__continue']
        .map((selector) => this.querySelector(selector))
        .find(Boolean);
      // A refused code leaves none applied, so the promo fold comes back shut over the field
      // the shopper is still working in.
      next?.closest('details')?.setAttribute('open', '');
      next?.focus({ preventScroll: true });
    }

    // How far the fade reaches at each end of the scrolling body: only where there is
    // something behind the edge, so a bag that fits has no fade at all.
    edges() {
      const body = this.querySelector('.bag__body');
      if (!body) return;
      const below = body.scrollHeight - body.clientHeight - body.scrollTop;
      body.style.setProperty('--edge-top', body.scrollTop > 4 ? '30px' : '0px');
      body.style.setProperty('--edge-bottom', below > 4 ? '30px' : '0px');
    }

    // Selectors that find the pressed control again once the bag has been re-rendered. A line
    // is found by its variant, not its key: Shopify re-keys a line when its quantity changes
    // (seen with this store's automatic discounts). A step at its limit comes back disabled,
    // and then the arrow takes focus rather than any button one more press would act on.
    hooks(control) {
      if (control.matches('[data-bag-wrap]')) return ['[data-bag-wrap]'];
      if (control.matches('[data-bag-promo], [data-bag-apply], [data-bag-unapply]')) return ['[data-bag-promo]'];
      const line = control.closest('[data-variant]');
      if (!line || !control.dataset.step) return [];
      return [`.bag__line[data-variant="${line.dataset.variant}"] [data-step="${control.dataset.step}"]:not(:disabled)`];
    }
  }

  customElements.define('cart-drawer', CartDrawer);
  customElements.define('cart-bag', CartBag);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collections"]) return;
  try {
    
  // Close the phone picker before the browser follows the category anchor.
  document.addEventListener('click', (event) => {
    const link = event.target.closest('.shop-page__picker a[href^="#"]');
    if (link) link.closest('details').open = false;
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["colour-story"] && !Shopify.designMode) return;
  try {
    
  // A colour pressed here swaps the photograph in place; a modified click (new tab) is left alone.
  document.addEventListener('click', (event) => {
    const link = event.target.closest?.('.hue__colour');
    if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

    const hue = link.closest('.hue');
    const img = hue?.querySelector('.hue__frame img');
    if (!img) return;

    event.preventDefault();
    img.srcset = link.dataset.srcset;
    img.src = link.dataset.src;
    img.alt = link.dataset.alt;

    const colour = hue.querySelector('.hue__caption-colour');
    if (colour) colour.textContent = link.dataset.colour;

    hue.querySelector('.hue__cta')?.setAttribute('href', link.getAttribute('href'));
    hue.querySelectorAll('.hue__colour[aria-current]').forEach((other) => other.removeAttribute('aria-current'));
    link.setAttribute('aria-current', 'true');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
  // In Customize, selecting a question opens its answer, so what is being edited is on screen.
  document.addEventListener('shopify:block:select', (event) => {
    const item = event.target.closest?.('.faq__item');
    if (item) item.open = true;
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  // The scrim behind the open menu is the <details>' own ::before, so a tap on it
  // lands on the <details> itself -- which does nothing by default. Close it.
  document.addEventListener('click', (event) => {
    const target = event.target;
    if (target instanceof HTMLDetailsElement && target.matches('.header__drawer[open]')) target.open = false;
  });

  // Escape shuts the open panel. It is held shut by `data-dismissed` -- focus is
  // put back on the nav link, which would otherwise keep `:focus-within` true --
  // until the pointer or focus leaves the item.
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const item =
      document.activeElement?.closest('.header__nav-item') ?? document.querySelector('.header__nav-item:hover');
    if (!item?.querySelector('.header__submenu')) return;
    item.setAttribute('data-dismissed', '');
    item.querySelector('.header__nav-link')?.focus();
  });

  // Lifted when the pointer comes back in from outside, or focus leaves -- NOT when
  // the pointer leaves: focus is still on the nav link then, and would reopen it.
  const reopen = (event) => {
    const item = event.target.closest?.('.header__nav-item');
    if (!item || item.contains(event.relatedTarget)) return;
    item.removeAttribute('data-dismissed');
    for (const tile of item.querySelectorAll('.is-lit')) tile.classList.remove('is-lit');
  };
  document.addEventListener('mouseover', reopen);
  document.addEventListener('focusout', reopen);

  // Pointing at (or tabbing to) a row lights the photograph of the same place.
  const lightTile = (event) => {
    const panel = event.target.closest?.('.header__submenu');
    if (!panel) return;
    const index = event.target.closest('[data-tile-link]')?.dataset.tileLink;
    for (const tile of panel.querySelectorAll('[data-tile]')) {
      tile.classList.toggle('is-lit', tile.dataset.tile === index);
    }
  };
  document.addEventListener('pointerover', lightTile);
  document.addEventListener('focusin', lightTile);

  // Shrink past 90px of scroll, grow back under 10px -- the gap stops a bar sitting on the
  // threshold from flickering. Looked up each time, so an editor re-render leaves nothing stale.
  let condenseFrame = 0;
  const condense = () => {
    condenseFrame = 0;
    const bar = document.querySelector('.header--condenses');
    if (scrollY > 90) bar?.classList.add('header--condensed');
    else if (scrollY < 10) bar?.classList.remove('header--condensed');
  };
  addEventListener('scroll', () => {
    if (!condenseFrame) condenseFrame = requestAnimationFrame(condense);
  }, { passive: true });
  condense();

  // The bar is one height however far it has shrunk -- the shrink is drawn, not laid out -- so
  // its height changes only with the width. Taken then, for the shrink (--header-h) and, on the
  // homepage, for pulling the page up under the bar (first set inline, straight after it).
  const measured = new WeakSet();
  const measure = () => {
    const bar = document.querySelector('.header');
    if (!bar || measured.has(bar)) return;
    measured.add(bar);
    new ResizeObserver(([entry]) => {
      const h = `${Math.round(entry.borderBoxSize[0].blockSize)}px`;
      bar.parentElement.style.setProperty('--header-h', h);
      if (!bar.classList.contains('header--float')) return;
      bar.parentElement.style.marginBlockEnd = `-${h}`;
      document.documentElement.style.setProperty('--header-rest-h', h);
    }).observe(bar);
  };
  measure();
  document.addEventListener('shopify:section:load', measure);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-vitrine"] && !Shopify.designMode) return;
  try {
    
  class HeroVitrine extends HTMLElement {
    connectedCallback() {
      this.slides = [...this.querySelectorAll('[data-hero-slide]')];
      this.copies = [...this.querySelectorAll('[data-hero-copy]')];
      this.nums = [...this.querySelectorAll('[data-hero-go]')];
      this.count = this.querySelector('[data-hero-count]');
      this.ribbons = [...this.querySelectorAll('[data-hero-ribbon]')];
      this.live = this.querySelector('.hero__copies');
      this.index = 0;

      // Taking the controls is a request to look: the carousel stops turning on
      // its own until the shopper presses play.
      this.querySelector('[data-hero-prev]')?.addEventListener('click', () => this.take(() => this.step(-1)));
      this.querySelector('[data-hero-next]')?.addEventListener('click', () => this.take(() => this.step(1)));
      this.nums.forEach((n) => n.addEventListener('click', () => this.take(() => this.go(+n.dataset.heroGo))));

      // Two pause buttons, one per breakpoint (a phone's in the card's corner,
      // desktop's in the arrow row). Only one is ever displayed; both say the same state.
      this.pauseButtons = [...this.querySelectorAll('[data-hero-pause]')];
      this.pauseButtons.forEach((b) => b.addEventListener('click', () => this.pause(!this.classList.contains('hero--paused'))));

      // What it listens to outside itself goes through one signal, so the theme
      // editor re-rendering the section leaves no observer or listener behind.
      this.abort = new AbortController();
      const { signal } = this.abort;

      // Nobody watching, nothing turning: scrolled mostly out of view, or a background tab.
      this.watch = new IntersectionObserver(([entry]) => this.classList.toggle('hero--offscreen', entry.intersectionRatio < 0.25), {
        threshold: 0.25,
      });
      this.watch.observe(this);
      document.addEventListener('visibilitychange', () => this.classList.toggle('hero--away', document.hidden), { signal });

      // The progress hairline IS the timer. Advancing when it finishes is what
      // keeps the indicator honest -- a separate interval would drift from it.
      this.addEventListener('animationend', (e) => {
        if (e.animationName === 'hero-fill') this.step(1);
      });

      // The theme editor. Picking a slide in the sidebar shows that slide -- the event
      // lands on whichever element carries the block's attributes, the bay or the copy --
      // and stops the turning, so what the merchant is typing stays in front of them.
      this.addEventListener('shopify:block:select', (event) => {
        const bay = event.target.closest('[data-hero-slide]');
        const i = bay ? this.slides.indexOf(bay) : this.copies.indexOf(event.target.closest('[data-hero-copy]'));
        if (i >= 0) this.take(() => this.go(i));
      });

      this.querySelectorAll('[data-hero-add]').forEach((b) => {
        b.closest('form')?.addEventListener('submit', (e) => this.add(e, b));
      });

      this.watchSwipe();

      // Every slide keeps the tallest slide's height. Measured now, again once the
      // web fonts have set the copy, and whenever the width changes and rewraps it.
      this.hold();
      document.fonts?.ready.then(() => this.hold());
      addEventListener('load', () => this.hold(), { once: true, signal });
      let frame = 0;
      const later = () => {
        cancelAnimationFrame(frame);
        frame = requestAnimationFrame(() => this.hold());
      };
      addEventListener('resize', later, { signal });
      // An app bar added above the hero after load, or closed by the shopper, moves it.
      this.moves = new MutationObserver(later);
      this.moves.observe(document.body, { childList: true });

      // Autoplay and the next slide's prefetch wait for slide 1's photograph.
      // decode() resolves once it has loaded and can paint; a failed image
      // still lets the carousel start.
      const first = this.slides[0]?.querySelector('.hero__frame--main img');
      (first ? first.decode().catch(() => {}) : Promise.resolve()).then(() => {
        this.slides[1]?.classList.add('is-next');
        this.classList.add('hero--ready');
      });
    }

    disconnectedCallback() {
      this.abort?.abort();
      this.watch?.disconnect();
      this.moves?.disconnect();
    }

    // Swipe, on touch only. Measured on pointerup rather than tracked during
    // the move, so the browser's own vertical scrolling is never intercepted --
    // a carousel that eats the page scroll is worse than one that cannot swipe.
    watchSwipe() {
      let x = 0;
      let y = 0;
      let live = false;

      this.addEventListener('pointerdown', (e) => {
        this.swiped = false;
        // Let a tap on the buttons, links and the rail behave as a tap. The
        // photographs are links too, but a swipe across them still turns the slide.
        if (e.pointerType !== 'touch' || e.target.closest('a:not(.hero__frame), button, input, select, textarea')) return;
        x = e.clientX;
        y = e.clientY;
        live = true;
      });

      this.addEventListener('pointerup', (e) => {
        if (!live) return;
        live = false;

        const dx = e.clientX - x;
        const dy = e.clientY - y;

        // Far enough, and more sideways than up: otherwise it was a scroll.
        if (Math.abs(dx) < 48 || Math.abs(dx) <= Math.abs(dy)) return;
        this.swiped = true;
        this.take(() => this.step(dx < 0 ? 1 : -1));
      });

      this.addEventListener('pointercancel', () => {
        live = false;
      });

      // A swipe that ends on a photograph is a swipe, not a tap on its link.
      this.addEventListener(
        'click',
        (e) => {
          if (!this.swiped) return;
          this.swiped = false;
          e.preventDefault();
          e.stopPropagation();
        },
        true
      );
    }

    // The shopper is steering now, so autoplay waits for them to press play.
    take(move) {
      this.pause(true);
      // Now the change is the shopper's own doing, so it is announced.
      this.live?.setAttribute('aria-live', 'polite');
      move();
    }

    pause(on) {
      this.classList.toggle('hero--paused', on);
      this.pauseButtons.forEach((b) => b.setAttribute('aria-pressed', String(on)));
    }

    // Room for the tallest card, and what sits above the hero. The measurement lives in the
    // inline script at the end of the section's markup, which takes it before first paint;
    // this re-takes it when the fonts or the width change. The card still fits the copy it
    // shows; .hero's grid rows keep the room around it.
    hold() {
      window.heroHold?.(this);
    }

    step(by) {
      const total = this.slides.length;
      this.go((this.index + by + total) % total);
    }

    go(next) {
      if (next === this.index || !this.slides[next]) return;
      this.index = next;

      const mark = (list, i) =>
        list.forEach((el, n) => el.classList.toggle('is-active', n === i));

      mark(this.slides, next);
      mark(this.nums, next);

      // Only the visible slide can be reached or tapped; the numeral says which it is.
      this.slides.forEach((el, n) => (el.inert = n !== next));
      this.nums.forEach((el, n) => (n === next ? el.setAttribute('aria-current', 'true') : el.removeAttribute('aria-current')));
      if (this.count) this.count.textContent = String(next + 1).padStart(2, '0');

      // Keep the following slide rendered so its images are already fetched
      // when it turns; everything else stays skipped.
      const upcoming = (next + 1) % this.slides.length;
      this.slides.forEach((el, n) => el.classList.toggle('is-next', n === upcoming));

      // The ribbon belongs to its slide; it is a sibling so it can sit above
      // the card's stacking context rather than inside the cross-fade.
      this.ribbons.forEach((el) => el.classList.toggle('is-active', +el.dataset.heroRibbon === next));

      // `visibility` via the class, not `hidden`: the copy keeps its box so
      // the card never resizes, while still leaving the reading order.
      this.copies.forEach((el, n) => el.classList.toggle('is-active', n === next));

      // Turning on its own, the incoming buttons are invisible for their first half
      // second, under a finger that may already be on its way to the outgoing ones.
      // They take no tap until they have lifted in. A shopper steering (paused) sees
      // the change they asked for, and reduced motion has no lift to wait for.
      const ctas = this.copies[next]?.querySelector('.hero__ctas');
      const lifts = ctas && !this.classList.contains('hero--paused') ? ctas.getAnimations() : [];
      if (lifts.length) {
        ctas.inert = true;
        Promise.allSettled(lifts.map((a) => a.finished)).then(() => (ctas.inert = false));
      }
    }

    add(event, button) {
      // Without the shared script (assets/cart-add.js) the form posts to the cart as normal.
      if (!window.addToBag) return;
      event.preventDefault();
      window.addToBag(button.closest('form'), button, button.querySelector('[data-hero-add-label]'));
    }
  }

  customElements.define('hero-vitrine', HeroVitrine);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["predictive-search"]) return;
  try {
    
  /*
   * The search panel. Opens from any `[data-search-open]` link, asks Shopify for an answer
   * once typing pauses, and lets the arrow keys walk everything it shows while focus stays
   * in the field (the combobox pattern). Recent searches live in this browser only.
   */
  class PredictiveSearch extends HTMLElement {
    static RECENT = 'crystalicious:recent-searches';

    connectedCallback() {
      this.disconnectedCallback();
      this.abort = new AbortController();
      const { signal } = this.abort;

      this.dialog = this.querySelector('dialog');
      this.field = this.querySelector('input[name="q"]');
      this.idle = this.querySelector('[data-psearch-idle]');
      this.results = this.querySelector('[data-psearch-results]');
      this.status = this.querySelector('[data-psearch-status]');
      this.answers = new Map();

      document.addEventListener(
        'click',
        (event) => {
          const opener = event.target.closest('[data-search-open]');
          // A modified click still opens /search in a new tab, as a link should.
          if (!opener || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          this.open(opener);
        },
        { signal }
      );

      // Every search form on the page, this one and the results page's, feeds the recent list.
      document.addEventListener(
        'submit',
        (event) => event.target.matches?.('form[role="search"]') && this.remember(event.target.elements.q?.value),
        { capture: true, signal }
      );

      this.field.addEventListener('input', () => this.queue(), { signal });
      this.field.addEventListener('keydown', (event) => this.key(event), { signal });

      this.dialog.addEventListener(
        'click',
        (event) => {
          if (event.target === this.dialog || event.target.closest('[data-psearch-close]')) return this.dialog.close();
          if (event.target.closest('[data-psearch-clear]')) {
            this.field.value = '';
            this.queue();
            return this.field.focus();
          }
          if (event.target.closest('[data-psearch-forget]')) {
            this.forget();
            return this.field.focus();
          }
          const term = event.target.closest('[data-psearch-term]');
          if (term) this.remember(term.dataset.psearchTerm);
        },
        { signal }
      );

      this.dialog.addEventListener(
        'close',
        () => {
          this.request?.abort();
          this.select(null);
          const back = this.opener?.isConnected ? this.opener : document.getElementById('MainContent');
          back?.focus({ preventScroll: true });
          this.opener = null;
        },
        { signal }
      );

      // A page restored by the back button may be showing an older recent list.
      addEventListener('pageshow', (event) => event.persisted && this.drawRecent(), { signal });

      this.drawRecent();
    }

    disconnectedCallback() {
      this.abort?.abort();
      this.request?.abort();
    }

    open(opener) {
      // On the results page the field is already there; go to it rather than open a second.
      const onPage = document.querySelector('[data-search-page] input[name="q"]');
      if (onPage) {
        onPage.focus();
        onPage.select();
        return;
      }

      if (!this.dialog.open) {
        // Quick view, a story or the bag gives way to search.
        document.querySelectorAll('dialog[open]').forEach((other) => other.close());
        const header = opener.closest('.header');
        const headerBox = header?.getBoundingClientRect();
        const condensedHeight = header
          ? Number.parseFloat(getComputedStyle(header).getPropertyValue('--header-condensed-h'))
          : Number.NaN;
        // The condensed header is translated inside its original layout box. Its box still ends
        // at the resting height, so using that bottom exposed a strip of the page above search.
        const visibleHeight = header?.classList.contains('header--condensed') && Number.isFinite(condensedHeight)
          ? condensedHeight
          : headerBox?.height || 0;
        const top = (headerBox?.top || 0) + visibleHeight;
        this.dialog.style.setProperty('--psearch-top', `${Math.max(0, Math.round(top))}px`);
        this.opener = opener;
        this.drawRecent();
        this.dialog.showModal();
        // Recent and popular searches are options too, so the field is expanded when any show.
        this.field.setAttribute('aria-expanded', String(this.options().length > 0));
      }

      this.field.focus();
      this.field.select();
    }

    /* ---------------------------------------------------------------- answers */

    queue() {
      const term = this.field.value.trim();
      this.querySelector('[data-psearch-clear]').hidden = !this.field.value;
      clearTimeout(this.timer);

      if (!term) {
        this.request?.abort();
        return this.show(null);
      }

      // Shopify has no predictive search in this storefront language; the results page still works.
      if (this.unsupported) return this.fallback(term);

      // Asked before in this visit: no request, and no pause either.
      const known = this.answers.get(term.toLowerCase());
      if (known) {
        this.request?.abort();
        return this.show(known);
      }

      this.timer = setTimeout(() => this.ask(term), 180);
    }

    async ask(term) {
      this.request?.abort();
      const request = (this.request = new AbortController());

      const url = new URL(this.dataset.suggestUrl, location.origin);
      url.searchParams.set('q', term);
      url.searchParams.set('section_id', 'predictive-search');
      url.searchParams.set('resources[type]', 'query,product,collection,article,page');
      url.searchParams.set('resources[limit]', '4');
      url.searchParams.set('resources[limit_scope]', 'each');
      url.searchParams.set('resources[options][unavailable_products]', 'last');
      url.searchParams.set('resources[options][fields]', 'title,product_type,variants.title,vendor,tag');

      this.dialog.setAttribute('aria-busy', 'true');
      try {
        const response = await fetch(url, { signal: request.signal });
        // 417 is Shopify's "Unsupported buyer locale". Stop asking.
        if (response.status === 417) {
          this.unsupported = true;
          if (this.field.value.trim() === term) this.fallback(term);
          return;
        }
        if (!response.ok) throw new Error(response.status);
        const answer = new DOMParser()
          .parseFromString(await response.text(), 'text/html')
          .querySelector('[data-psearch-answer]');
        const entry = { html: answer.innerHTML, status: answer.dataset.status };
        this.answers.set(term.toLowerCase(), entry);
        if (this.field.value.trim() === term) this.show(entry);
      } catch (error) {
        if (request.signal.aborted) return;
        // Enter still reaches the results page, which does not depend on this request.
        if (this.field.value.trim() === term) this.fallback(term, this.dataset.error);
      } finally {
        if (this.request === request) this.dialog.removeAttribute('aria-busy');
      }
    }

    // No answer to show: offer the results page for the words, as an option the arrows reach.
    fallback(term, message) {
      const link = document.createElement('a');
      link.className = 'psearch__all text-link';
      link.id = 'psearch-all';
      link.href = this.dataset.searchUrl + encodeURIComponent(term);
      link.dataset.psearchTerm = term;
      link.setAttribute('role', 'option');
      link.setAttribute('aria-selected', 'false');
      // A function, so a `$&` typed into the field is not read as a replacement pattern.
      link.textContent = this.dataset.viewAll.replace('*', () => term);

      const note = document.createElement('p');
      note.className = 'psearch__none-hint';
      note.textContent = message || '';
      this.show({ html: (message ? note.outerHTML : '') + link.outerHTML, status: message || link.textContent });
    }

    show(answer) {
      this.select(null);
      this.idle.hidden = !!answer;
      this.results.hidden = !answer;
      this.results.innerHTML = answer ? answer.html : '';
      this.status.textContent = answer ? answer.status : '';
      this.field.setAttribute('aria-expanded', String(this.options().length > 0));
    }

    /* --------------------------------------------------------------- keyboard */

    options() {
      return [...this.dialog.querySelectorAll('[role="option"]')].filter((option) => option.getClientRects().length);
    }

    select(option) {
      this.active?.setAttribute('aria-selected', 'false');
      this.active = option;
      if (!option) return this.field.removeAttribute('aria-activedescendant');
      option.setAttribute('aria-selected', 'true');
      this.field.setAttribute('aria-activedescendant', option.id);
      option.scrollIntoView({ block: 'nearest' });
    }

    key(event) {
      if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
        const options = this.options();
        if (!options.length) return;
        event.preventDefault();
        const at = options.indexOf(this.active);
        const step = event.key === 'ArrowDown' ? 1 : -1;
        this.select(options[(at + step + options.length + (at < 0 && step < 0 ? 1 : 0)) % options.length]);
      } else if (event.key === 'Enter' && this.active?.isConnected) {
        event.preventDefault();
        this.active.click();
      } else if (event.key === 'Escape') {
        // A search field's own Escape empties it and would keep the panel open.
        event.preventDefault();
        this.dialog.close();
      }
    }

    /* ----------------------------------------------------------------- recent */

    recent() {
      try {
        const list = JSON.parse(localStorage.getItem(PredictiveSearch.RECENT));
        return Array.isArray(list) ? list.filter((term) => typeof term === 'string') : [];
      } catch {
        return [];
      }
    }

    remember(value) {
      const term = value?.trim();
      if (!term) return;
      const list = [term, ...this.recent().filter((old) => old.toLowerCase() !== term.toLowerCase())].slice(0, 5);
      try {
        localStorage.setItem(PredictiveSearch.RECENT, JSON.stringify(list));
      } catch {}
    }

    forget() {
      try {
        localStorage.removeItem(PredictiveSearch.RECENT);
      } catch {}
      this.drawRecent();
      this.show(null);
    }

    drawRecent() {
      const list = this.recent();
      const group = this.querySelector('[data-psearch-recent]');
      group.hidden = !list.length;
      this.querySelector('[data-psearch-recent-list]').replaceChildren(
        ...list.map((term, index) => {
          const item = document.createElement('li');
          const link = document.createElement('a');
          item.setAttribute('role', 'none');
          link.className = 'search-terms__link';
          link.id = `psearch-recent-${index + 1}`;
          link.href = this.dataset.searchUrl + encodeURIComponent(term);
          link.textContent = term;
          link.dataset.psearchTerm = term;
          link.setAttribute('role', 'option');
          link.setAttribute('aria-selected', 'false');
          item.append(link);
          return item;
        })
      );
    }
  }

  customElements.define('predictive-search', PredictiveSearch);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  /*
   * The product page around the shared picker (snippets/variant-picker.liquid): it follows
   * each pick with the gallery, the URL, the price caption, the delivery lines,
   * and the sticky bar.
   */
  class ProductPage extends HTMLElement {
    connectedCallback() {
      this.gallery = this.querySelector('[data-gallery]');
      this.track = this.querySelector('[data-gallery-track]');
      this.colourIndex = Number(this.querySelector('[data-qv-colour]')?.dataset.qvOption) - 1;

      this.addEventListener('variant:change', (event) => this.follow(event.detail));
      this.wireQuantity();
      this.wireGallery();
      this.wireFilm();
      this.pinUnderHeader();
      this.wireZoom();
      this.wirePanel();
      this.wireFolds();
      this.wireBack();
      this.wireFree();
      this.wireArrival();

      // The picker is assets/quick-view.js, deferred at the foot of the page: it may run after this.
      if (window.variantPicker) window.variantPicker(this);
      else document.addEventListener('DOMContentLoaded', () => window.variantPicker(this), { once: true });
    }

    follow({ variant, open }) {
      this.classList.toggle('is-unavailable', !variant);
      this.syncQuantity(variant, open);
      if (!variant) {
        this.classList.remove('is-sold', 'is-unpriced');
        this.querySelectorAll('.pdp__buy, .pdp-bar__buy').forEach((button) => (button.disabled = true));
        return;
      }
      const sold = !open && !variant.available;
      const unpriced = Number(variant.amount) <= 0;
      this.classList.toggle('is-sold', sold);
      this.classList.toggle('is-unpriced', unpriced);
      this.querySelectorAll('.pdp__buy, .pdp-bar__buy').forEach((button) => {
        button.disabled = sold || unpriced;
      });
      const picked = [...this.querySelectorAll('.qv__option:not([hidden]) [data-qv-option]:checked')].map((radio) => radio.value);
      if (unpriced) {
        this.querySelectorAll('[data-qv-add]').forEach((button) => (button.disabled = true));
        const message = picked.length
          ? this.dataset.enquirePicked.replace('[variant]', picked.join(' / '))
          : this.dataset.enquireMessage;
        this.querySelectorAll('.pdp__enquire, .pdp-bar__enquire').forEach((link) => {
          link.href = `${link.href.split('?')[0]}?text=${encodeURIComponent(message)}`;
        });
      }

      // "Tell me when it's back" names what she picked -- the rows that were a choice, as the bag
      // names them -- so the shop knows what to restock and whom to tell without writing back.
      if (sold) {
        if (picked.length) {
          const text = this.dataset.notifyPicked.replace('[variant]', picked.join(' / '));
          this.querySelectorAll('.pdp__notify, .pdp-bar__notify').forEach((link) => {
            link.href = `${link.href.split('?')[0]}?text=${encodeURIComponent(text)}`;
          });
        }
      }

      const save = this.querySelector('[data-pdp-save]');
      if (save) {
        save.hidden = !variant.save;
        save.textContent = save.dataset.template.replace('[percent]', variant.save);
      }

      this.amount = variant.amount;
      this.choiceOpen = open;
      this.countFree();

      // What is left, on the photograph (snippets/product-gallery.liquid), counts the whole piece.
      // The moment a picked size has a count of its own, the picker's line names that size and this
      // one would stand beside it saying a different number about a different thing.
      const left = this.querySelector('[data-pdp-left]');
      if (left) left.hidden = !open && variant.left !== null && variant.left > 0 && variant.left <= 3;


      if (this.colourIndex >= 0) {
        this.showColour(variant.options[this.colourIndex]);
      }

      // A whole variant is a link worth sharing: it opens on this colourway, previews its
      // photograph (snippets/meta-tags.liquid), and asks whoever opens it for their own size.
      if (!open) {
        const url = new URL(location.href);
        if (url.searchParams.get('variant') !== String(variant.id)) {
          url.searchParams.set('variant', variant.id);
          history.replaceState(history.state, '', url);
        }
      }

    }

    wireQuantity() {
      this.quantity = this.querySelector('[data-pdp-qty]');
      this.quantityMinus = this.querySelector('[data-pdp-qty-minus]');
      this.quantityPlus = this.querySelector('[data-pdp-qty-plus]');
      if (!this.quantity) return;

      this.quantityMinus.addEventListener('click', () => this.setQuantity(Number(this.quantity.value) - 1));
      this.quantityPlus.addEventListener('click', () => this.setQuantity(Number(this.quantity.value) + 1));
      this.quantity.addEventListener('change', () => this.setQuantity(Number(this.quantity.value)));
      this.quantity.addEventListener('input', () => {
        this.updateQuantityButtons();
        const value = Number(this.quantity.value);
        if (Number.isSafeInteger(value) && value > 0 && (!this.quantity.max || value <= Number(this.quantity.max))) {
          this.dispatchEvent(new CustomEvent('quantity:change', { detail: { quantity: value } }));
        }
      });
    }

    setQuantity(value) {
      if (!this.quantity) return;
      const max = Number(this.quantity.max) || Infinity;
      this.quantity.value = Math.min(max, Math.max(1, Number.isFinite(value) ? Math.trunc(value) : 1));
      this.updateQuantityButtons();
      this.dispatchEvent(new CustomEvent('quantity:change', { detail: { quantity: Number(this.quantity.value) } }));
    }

    updateQuantityButtons() {
      if (!this.quantity) return;
      const value = Number(this.quantity.value);
      this.quantityMinus.disabled = this.quantity.disabled || !value || value <= 1;
      this.quantityPlus.disabled = this.quantity.disabled || (this.quantity.max && value >= Number(this.quantity.max));
    }

    syncQuantity(variant, open) {
      if (!this.quantity) return;
      this.quantity.disabled = !variant || (!open && (!variant.available || Number(variant.amount) <= 0));
      if (!open && variant?.available && Number.isFinite(variant.left) && variant.left > 0) {
        this.quantity.max = variant.left;
      } else {
        this.quantity.removeAttribute('max');
      }
      this.setQuantity(Number(this.quantity.value));
    }

    /* ------------------------------------------------------------- gallery */

    slides() {
      return [...this.track.children].filter((slide) => !slide.hidden);
    }

    showColour(colour) {
      const grouped = [...this.track.children].filter((slide) => 'colour' in slide.dataset);
      if (!grouped.length || colour === this.colour) return;
      this.colour = colour;

      // A colourway with no photographs of its own shows them all rather than none.
      const own = grouped.some((slide) => slide.dataset.colour === colour);
      grouped.forEach((slide) => (slide.hidden = own && slide.dataset.colour !== colour));
      // A new colourway starts at its first slide, not wherever the last one was left, and its film
      // may hand over again.
      this.track.scrollTo({ left: 0, behavior: 'instant' });
      this.handover = true;
      this.status(true);
    }

    wireGallery() {
      if (!this.track) return;
      this.dashes = this.querySelector('[data-gallery-dashes]');
      this.count = this.querySelector('[data-gallery-count]');

      let frame = 0;
      const follow = () => {
        cancelAnimationFrame(frame);
        frame = requestAnimationFrame(() => this.status(false));
      };
      this.track.addEventListener('scroll', follow, { passive: true });
      // A turned phone changes every slide's height with its width.
      this.onResize = follow;
      window.addEventListener('resize', follow);
      this.status(false);

      // A dash goes to its slide, by tap or by key, and counts as touching the gallery: a playing
      // film stops handing over by itself.
      this.dashes.addEventListener('click', (event) => {
        const dash = event.target.closest('[data-gallery-go]');
        if (!dash) return;
        this.handover = false;
        this.goToSlide(Number(dash.dataset.galleryGo));
      });
    }

    // Slides are a screen wide.
    goToSlide(index) {
      const still = matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.track.scrollTo({ left: index * this.track.clientWidth, behavior: still ? 'instant' : 'smooth' });
    }

    status(rebuild) {
      const slides = this.slides();
      const total = slides.length;
      this.track.classList.toggle('is-single', total === 1);
      const width = this.track.clientWidth || 1;
      const index = Math.min(total - 1, Math.round(Math.abs(this.track.scrollLeft) / width));

      this.count.parentElement.hidden = total < 2;
      if (rebuild) {
        const label = this.dashes.dataset.label;
        this.dashes.replaceChildren(
          ...Array.from({ length: total }, (_, i) => {
            const dash = document.createElement('button');
            dash.type = 'button';
            dash.className = 'pdp-gallery__dash';
            dash.dataset.galleryGo = i;
            dash.setAttribute('aria-label', label.replace('[n]', i + 1).replace('[total]', total));
            return dash;
          })
        );
      }
      [...this.dashes.children].forEach((dash, i) => {
        dash.classList.toggle('is-current', i === index);
        if (i === index) dash.setAttribute('aria-current', 'true');
        else dash.removeAttribute('aria-current');
      });
      this.count.textContent = `${index + 1}/${total}`;
    }

    wireZoom() {
      const dialog = this.querySelector('[data-zoom-dialog]');
      const track = this.querySelector('[data-zoom-track]');
      if (!dialog) return;
      const count = dialog.querySelector('[data-zoom-count]');
      const steps = [...dialog.querySelectorAll('[data-zoom-step]')];

      // Which photograph is showing, and the steps either side of it. A step at an end is marked,
      // not disabled, so a keyboard user's focus stays on it.
      const at = () => Math.round(Math.abs(track.scrollLeft) / (track.clientWidth || 1));
      const place = () => {
        const total = track.children.length;
        const index = Math.min(total - 1, at());
        // A photograph moved away from lets go of its magnification.
        [...track.children].forEach((item, i) => i !== index && item.classList.remove('is-magnified'));
        count.textContent = `${index + 1}/${total}`;
        count.hidden = total < 2;
        steps.forEach((step) => {
          step.hidden = total < 2;
          const end = Number(step.dataset.zoomStep) < 0 ? index === 0 : index === total - 1;
          step.setAttribute('aria-disabled', String(end));
        });
      };
      const go = (delta) => {
        const target = track.children[Math.min(track.children.length - 1, Math.max(0, at() + delta))];
        const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
        target?.scrollIntoView({ block: 'nearest', inline: 'start', behavior: reduce ? 'instant' : 'smooth' });
      };

      steps.forEach((step) => step.addEventListener('click', () => go(Number(step.dataset.zoomStep))));

      // A computer has no pinch: a click magnifies around the point clicked, the pointer moves the
      // view, and a second click lets it go.
      if (matchMedia('(hover: hover) and (pointer: fine)').matches) {
        const aim = (item, event) => {
          const box = item.getBoundingClientRect();
          item.style.setProperty('--zoom-x', `${((event.clientX - box.left) / box.width) * 100}%`);
          item.style.setProperty('--zoom-y', `${((event.clientY - box.top) / box.height) * 100}%`);
        };
        track.addEventListener('click', (event) => {
          const item = event.target.closest('li');
          if (!item) return;
          aim(item, event);
          item.classList.toggle('is-magnified');
        });
        track.addEventListener('pointermove', (event) => {
          const item = event.target.closest('li.is-magnified');
          if (item) aim(item, event);
        });
      }
      // Arrow keys step through the photographs.
      dialog.addEventListener('keydown', (event) => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        go(event.key === 'ArrowRight' ? 1 : -1);
      });
      let frame = 0;
      track.addEventListener(
        'scroll',
        () => {
          cancelAnimationFrame(frame);
          frame = requestAnimationFrame(place);
        },
        { passive: true }
      );

      this.track.addEventListener('click', (event) => {
        const button = event.target.closest('[data-zoom]');
        if (!button) return;

        // Photographs only: a film's poster is not a photograph to zoom into.
        const photos = this.slides().filter((slide) => slide.querySelector('[data-zoom]'));
        const index = photos.indexOf(button.closest('li'));
        track.replaceChildren(
          ...photos.map((slide, i) => {
            const item = document.createElement('li');
            const image = slide.querySelector('img').cloneNode();
            // Zoom is where crystals are counted, and the view magnifies to 2.5 (the dialog's
            // `.is-magnified` rule, and a phone's own pinch goes further still). At 100vw the
            // browser picks the candidate for life size and magnifies that, so a 430pt phone
            // inspects a 1500px photograph blown up past three thousand. Asking for the magnified
            // width instead picks the largest the piece has.
            image.sizes = '250vw';
            // Only the photograph that was tapped is fetched at once. A colourway can have 25, and
            // all of them asked for at their largest together left the one she wanted waiting its
            // turn on a blank screen; the rest load as she swipes toward them.
            image.loading = i === index ? 'eager' : 'lazy';
            item.append(image);
            return item;
          })
        );
        dialog.showModal();
        track.children[index]?.scrollIntoView({ block: 'nearest', inline: 'start', behavior: 'instant' });
        place();
        this.zoomOpener = button;
      });

      dialog.querySelector('[data-zoom-close]').addEventListener('click', () => dialog.close());
      dialog.addEventListener('close', () => {
        track.replaceChildren();
        this.zoomOpener?.focus({ preventScroll: true });
      });
    }

    /* ---------------------------------------------------------------- film */

    // The piece's film: muted, inline, no controls, playing while most of it is in view. On a phone,
    // after one full play it hands over to the next slide -- once, and only if the shopper has not
    // touched the gallery and is still at the top, where the frame changing height moves nothing
    // they are reading. Otherwise, and on desktop, it loops. A tap pauses or plays it, and anyone
    // who asked for less motion gets the poster until they tap.
    wireFilm() {
      const films = this.track ? [...this.track.querySelectorAll('video')] : [];
      if (!films.length) return;
      const still = matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.handover = true;
      ['pointerdown', 'wheel', 'keydown'].forEach((type) =>
        this.track.addEventListener(type, () => (this.handover = false), { passive: true })
      );

      this.filmWatch = new IntersectionObserver(
        (entries) =>
          entries.forEach(({ target, intersectionRatio }) => {
            if (intersectionRatio >= 0.6 && !still && !('held' in target.dataset)) target.play().catch(() => {});
            else target.pause();
          }),
        { threshold: [0, 0.6] }
      );

      const handOver = (film) => {
        const slides = this.slides();
        const index = slides.indexOf(film.closest('li'));
        const showing = Math.round(Math.abs(this.track.scrollLeft) / (this.track.clientWidth || 1));
        const phone = matchMedia('(max-width: 749px)').matches;
        if (!this.handover || !phone || index !== showing || index === slides.length - 1 || scrollY > 40) return false;

        this.handover = false;
        this.goToSlide(index + 1);
        return true;
      };

      films.forEach((film) => {
        const toggle = film.closest('.pdp-gallery__slide')?.querySelector('[data-film-toggle]');
        const syncToggle = () => {
          if (!toggle) return;
          toggle.classList.toggle('is-paused', film.paused);
          toggle.setAttribute('aria-label', film.paused ? toggle.dataset.play : toggle.dataset.pause);
        };
        const toggleFilm = () => {
          if (film.paused) {
            delete film.dataset.held;
            film.play().catch(() => {});
          } else {
            film.dataset.held = '';
            film.pause();
          }
        };
        // iOS decides autoplay from the property as well as the attribute.
        film.muted = true;
        film.addEventListener('play', syncToggle);
        film.addEventListener('pause', syncToggle);
        film.addEventListener('ended', () => {
          // Handed over: back to its start, ready for when the shopper swipes back.
          if (handOver(film)) film.currentTime = 0;
          else film.play().catch(() => {});
        });
        film.addEventListener('click', toggleFilm);
        toggle?.addEventListener('click', toggleFilm);
        syncToggle();
        this.filmWatch.observe(film);
      });
    }

    /* ------------------------------------------------------- phone frame */

    wirePanel() {
      // A phone's photograph is re-measured when the panel width changes (rotation or resize).
      const panel = this.querySelector('.pdp__panel');
      if (!panel) return;
      let width = panel.offsetWidth;
      this.panelWatch = new ResizeObserver(() => {
        if (panel.offsetWidth === width) return;
        width = panel.offsetWidth;
        window.pdpFit?.(this);
      });
      // Measured before paint in the fallback fonts; once the web fonts have set the name, again.
      document.fonts?.ready.then(() => window.pdpFit?.(this));
      this.panelWatch.observe(panel);
    }

    disconnectedCallback() {
      this.panelWatch?.disconnect();
      this.headerSize?.disconnect();
      this.filmWatch?.disconnect();
      if (this.onResize) window.removeEventListener('resize', this.onResize);
      clearInterval(this.arrivalClock);
      if (this.onCart) document.removeEventListener('cart:updated', this.onCart);
    }

    // Phones pin the photograph under the header when the header sticks, at its shrunk height
    // (the header has shrunk long before the photograph reaches it). The facets bar does the same.
    pinUnderHeader() {
      const header = document.querySelector('header')?.closest('.shopify-section');
      if (!header) return;
      const measure = () => {
        const bar = header.querySelector('.header--condenses');
        const shrunk = bar && parseFloat(getComputedStyle(bar).getPropertyValue('--header-condensed-h'));
        const top = getComputedStyle(header).position === 'sticky' ? shrunk || header.offsetHeight : 0;
        this.style.setProperty('--pdp-gallery-top', `${top}px`);
      };
      measure();
      this.headerSize = new ResizeObserver(measure);
      this.headerSize.observe(header);
    }

    /* ------------------------------------------------------------- folds */

    wireFolds() {
      if (!matchMedia('(max-width: 749px)').matches) return;

      // A phone opens on the first fold alone: the rest are one tap away, and the rails under
      // them are reachable without scrolling past three open blocks. Closed here and not in the
      // markup, so a page without script keeps every fold open and reads as one column.
      this.querySelectorAll('.pdp-fold').forEach((fold, i) => {
        if (i > 0) fold.open = false;
      });
    }

    /* ----------------------------------------------------------- the back */

    // Arrived from a list of pieces on this shop, the back link returns to it rather than opening
    // the shelf fresh, so its filters, its scroll and the pages it had loaded are still there. The
    // phone's link on the photograph is always drawn; the desktop's, over the trail, only for her.
    wireBack() {
      const backs = [...this.querySelectorAll('[data-pdp-back]')];
      if (!backs.length || !document.referrer) return;
      const from = new URL(document.referrer);
      const listing = /\/(collections|search)(\/|$)/.test(from.pathname) && !from.pathname.includes('/products/');
      if (from.origin !== location.origin || !listing) return;

      backs.forEach((back) => {
        back.hidden = false;
        back.addEventListener('click', (event) => {
          if (event.metaKey || event.ctrlKey || event.shiftKey || history.length < 2) return;
          event.preventDefault();
          history.back();
        });
      });
    }

    /* ----------------------------------------------------------- delivery */

    // The shipping line follows both the bag and the selected piece.
    wireFree() {
      this.free = this.querySelector('[data-pdp-free]');
      if (!this.free) return;
      this.onCart = (event) => {
        if (!event.detail.cart) return;
        this.free.dataset.cart = event.detail.cart.total_price;
        this.countFree();
      };
      document.addEventListener('cart:updated', this.onCart);
    }

    countFree() {
      if (!this.free || this.amount === undefined) return;
      const { threshold, cart, format, gap, doneLine, withPiece } = this.free.dataset;
      const bar = Number(threshold);
      const inBag = Number(cart);
      const left = bar - inBag;
      const reached = left <= 0;
      const reaches = !reached && !this.choiceOpen && inBag + this.amount >= bar;
      const amount = format.replace(/\{\{\s*\w+\s*\}\}/, Math.ceil(left / 100).toLocaleString('en-US'));
      this.free.textContent = reached ? doneLine : reaches ? withPiece : gap.replace('[amount]', amount);
      const charge = this.querySelector('[data-pdp-charge]');
      if (charge) charge.hidden = reached || reaches;
    }

    // The arrival date follows the store clock and delivery schedule at the dispatch cut-off.
    wireArrival() {
      const line = this.querySelector('[data-pdp-arrival]');
      if (!line) return;
      const { cutoff, from, to, closed, offset, locale } = line.dataset;
      const block = this.querySelector('[data-pdp-arrival-block]');
      const shift = (offset[0] === '-' ? -1 : 1) * (Number(offset.slice(1, 3)) * 60 + Number(offset.slice(3, 5)));
      // In the shopper's language as their country writes dates: "Fri, 18 Sep" in India.
      const format = new Intl.DateTimeFormat(locale, {
        weekday: 'short',
        day: 'numeric',
        month: 'short',
        timeZone: 'UTC',
      });
      const runs = (day) => day.getUTCDay() !== Number(closed);
      const next = (day) => {
        let later = new Date(day.getTime() + 864e5);
        while (!runs(later)) later = new Date(later.getTime() + 864e5);
        return later;
      };

      const tick = () => {
        // Shifted by the store's offset and read through the UTC getters: the store's wall clock.
        const now = new Date(Date.now() + shift * 60000);
        const today = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate()));
        const left = Number(cutoff) * 60 - (now.getUTCHours() * 60 + now.getUTCMinutes());
        const dispatchToday = left > 0 && runs(today);

        const ship = dispatchToday ? today : next(today);
        let first = ship;
        for (let i = 0; i < Number(from); i++) first = next(first);
        let last = first;
        for (let i = Number(from); i < Number(to); i++) last = next(last);

        const date =
          +first === +last
            ? format.format(first)
            : format.formatRange?.(first, last) || `${format.format(first)} – ${format.format(last)}`;
        line.textContent = date;
        if (block) block.hidden = false;
      };

      tick();
      this.arrivalClock = setInterval(tick, 60000);
    }
  }

  if (!customElements.get('product-page')) customElements.define('product-page', ProductPage);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recently-viewed"] && !Shopify.designMode) return;
  try {
    
  class RecentlyViewed extends HTMLElement {
    static key = 'crystalicious:viewed';

    connectedCallback() {
      const { handle, limit } = this.dataset;
      let seen = [];
      // Storage can be missing or refused (a private window); the page carries on without it.
      try {
        seen = JSON.parse(localStorage.getItem(RecentlyViewed.key)) || [];
      } catch {}

      const earlier = seen.filter((other) => other !== handle);
      if (handle) {
        try {
          localStorage.setItem(RecentlyViewed.key, JSON.stringify([handle, ...earlier].slice(0, 12)));
        } catch {}
      }
      if (!earlier.length) return;

      const handles = earlier.slice(0, Number(limit));
      if (!RecentlyViewed.bagHolds()) {
        this.load(handles);
        return;
      }
      // /cart with pieces in the bag. The bag re-renders on the same event, after this
      // listener, so it is read once that has run.
      this.abort = new AbortController();
      document.addEventListener(
        'cart:updated',
        () =>
          setTimeout(() => {
            if (RecentlyViewed.bagHolds() || this.loaded) return;
            this.loaded = true;
            this.abort.abort();
            this.load(handles);
          }),
        { signal: this.abort.signal }
      );
    }

    disconnectedCallback() {
      this.abort?.abort();
    }

    static bagHolds() {
      return !!document.querySelector('.bag-page .bag__line');
    }

    async load(handles) {
      try {
        const url = new URL(this.dataset.url, location.origin);
        url.searchParams.set('q', handles.map((handle) => `handle:${handle}`).join(' OR '));
        url.searchParams.set('type', 'product');
        url.searchParams.set('options[prefix]', 'none');
        url.searchParams.set('section_id', 'recently-viewed');
        const res = await fetch(url);
        if (!res.ok) return;

        const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
        const list = doc.querySelector('.recs__list');
        if (!list) return;

        // Search answers by relevance and may match a near name; keep exactly the viewed pieces,
        // in the order they were viewed.
        const byHandle = new Map(
          [...list.children].map((card) => {
            const href = card.querySelector('a[href*="/products/"]')?.getAttribute('href') || '';
            return [new URL(href, location.origin).pathname.split('/').pop(), card];
          })
        );
        const cards = handles.map((handle) => byHandle.get(handle)).filter(Boolean);
        if (!cards.length) return;

        // Search tags its links to count its own clicks; these pieces were not found by a search.
        cards.forEach((card) =>
          card.querySelectorAll('a[href*="?"], [data-quick-view*="?"]').forEach((link) => {
            const attr = link.hasAttribute('data-quick-view') ? 'data-quick-view' : 'href';
            link.setAttribute(attr, link.getAttribute(attr).split('?')[0]);
          })
        );

        list.replaceChildren(...cards);
        this.append(list);
      } catch {
        // Nothing to show is a quiet section, never a broken one.
      }
    }
  }

  if (!customElements.get('recently-viewed')) customElements.define('recently-viewed', RecentlyViewed);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stories"] && !Shopify.designMode) return;
  try {
    
  /*
   * Stories.
   *
   * The covers are on the page; the reel is not. Pressing a cover opens the
   * player, and because that press is a real gesture the browser will let the
   * sound start with it -- which is the whole reason the player sits behind a
   * press rather than inline.
   *
   * Stepping between stories swaps three things at once -- the reel, its panel
   * and the count -- so they live behind one element rather than three
   * listeners that can disagree.
   *
   * Adding to the bag goes through assets/cart-add.js, shared with the hero and
   * quick view. A piece that still needs a size or colour never gets that far:
   * its button opens quick view instead.
   */
  class StoriesRail extends HTMLElement {
    /*
     * Not the theme's `--ease-entrance`: that spends 95% of its travel in the
     * first fifth, which is right for something arriving at rest and wrong for
     * something the eye is meant to follow across the screen.
     */
    static EASE = 'cubic-bezier(0.32, 0.72, 0, 1)';

    // The stories this device has watched, by block id, so a cover's ring turns grey once seen.
    static SEEN = 'crystalicious:stories-seen';

    connectedCallback() {
      this.railVideos = [...this.querySelectorAll('[data-rail-video]')];
      this.quiet = matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.current = -1;
      this.opener = null;

      // Covers already watched on this device show a grey ring rather than a Royale Blue one.
      const seen = this.seen();
      this.querySelectorAll('[data-story-id]').forEach((card) => card.classList.toggle('is-seen', seen.has(card.dataset.storyId)));

      this.addEventListener('click', (event) => this.onClick(event));
      this.addEventListener('submit', (event) => this.add(event));
      this.watchRail();
      this.watchReels();

      // Reaching for a cover -- a pointer over it, a finger down, Tab onto it -- starts
      // fetching the player, so the press that follows finds it already on its way.
      const reach = (event) => {
        if (event.target.closest('[data-story-open]')) this.playerTemplate();
      };
      this.addEventListener('pointerover', reach, { passive: true });
      this.addEventListener('pointerdown', reach, { passive: true });
      this.addEventListener('focusin', reach);

      // In Customize, selecting a story in the sidebar slides the rail to its cover, so the story
      // being edited is on screen and not past the rail's edge.
      this.addEventListener('shopify:block:select', (event) =>
        event.target.scrollIntoView({ block: 'nearest', inline: 'center', behavior: this.quiet ? 'auto' : 'smooth' })
      );
    }

    /*
     * The reels on the covers. Each is a whole video file, so the rail only asks for the
     * ones a shopper is about to see: the covers at least half inside the rail, and the
     * one after them. Swiping or stepping the rail moves that window.
     *
     * Two stages, so nothing downloads that is not being watched. A screen's height ahead
     * -- while the section above is still being read -- a reel fetches only its metadata,
     * so it can start the moment it is needed. On screen it plays and streams. Paused
     * again, it goes back to metadata, which tells the browser to stop filling its buffer.
     *
     * It used to be every cover touching the screen, from 200px before it, each buffering
     * its whole file: three reels on a phone, the sliver of the third included (5.5MB in
     * eight seconds), and five at once at 1366px -- and on a laptop, where the rail sits
     * within a screen of the top, whole files before anyone scrolled at all.
     *
     * A shopper saving data, on a slow line, or asking for less motion keeps the still
     * covers and downloads no reels at all.
     */
    watchReels() {
      const line = navigator.connection;
      const slowLine = !!line && (line.saveData || /(^|-)2g|3g/.test(line.effectiveType || ''));
      const rail = this.querySelector('.stories__rail');
      if (!rail || !this.railVideos.length || this.quiet || slowLine) return;

      const items = [...rail.children];
      const loading = new Set();
      const signal = (this.reelAbort = new AbortController()).signal;
      let near = false;
      let onScreen = false;
      let frame = 0;

      const sync = () => {
        frame = 0;
        const view = rail.getBoundingClientRect();
        // How much of each cover is inside the rail. Reading order is DOM order in both
        // directions, so "the one after" is the next item whichever way the rail runs.
        const inside = items.map((item) => {
          const box = item.getBoundingClientRect();
          return Math.max(0, Math.min(box.right, view.right) - Math.max(box.left, view.left)) / box.width;
        });
        const next = inside.findLastIndex((share) => share >= 0.5) + 1;

        items.forEach((item, i) => {
          const video = item.querySelector('[data-rail-video]');
          if (!video) return;
          const wanted = near && (inside[i] >= 0.5 || i === next);

          // Out of the window: stop, and give up any download still running. Pausing
          // alone does not -- a paused reel went on filling its buffer, 1.2MB in twelve
          // seconds for covers nobody could see. load() with nothing to preload aborts
          // the request; coming back fetches again, mostly from the browser's cache.
          if (!wanted) {
            if (!loading.has(video)) return;
            loading.delete(video);
            video.pause();
            video.classList.remove('is-running');
            video.preload = 'none';
            video.load();
            return;
          }

          if (!loading.has(video)) {
            loading.add(video);
            video.preload = 'metadata';
            video.load();
          }

          if (onScreen && inside[i] > 0) {
            if (!video.paused) return;
            video.preload = 'auto';
            video.play().catch(() => {});
          } else if (!video.paused) {
            video.pause();
          }
        });
      };
      const later = () => {
        frame ||= requestAnimationFrame(sync);
      };

      // Revealed over its still once it is actually playing, so a cover never shows an
      // empty box waiting for a first frame -- including after it was let go and reloaded.
      this.railVideos.forEach((video) =>
        video.addEventListener('playing', () => video.classList.add('is-running'), { signal })
      );

      rail.addEventListener('scroll', later, { passive: true, signal });
      addEventListener('resize', later, { signal });

      // One screen ahead to start loading; on screen to play.
      this.reelsNear = new IntersectionObserver(
        ([entry]) => {
          near = entry.isIntersecting;
          later();
        },
        { rootMargin: '100% 0px' }
      );
      this.reelsSeen = new IntersectionObserver(([entry]) => {
        onScreen = entry.isIntersecting;
        later();
      });
      this.reelsNear.observe(rail);
      this.reelsSeen.observe(rail);
    }

    /*
     * The player's <template>. In the theme editor it is already in the section. On the
     * page it is not, so this section is asked for again through the Section Rendering API,
     * which renders it with the player (see the Liquid above). The request itself is kept,
     * not its answer, so a press landing while it is on its way joins it instead of
     * starting a second. A failure is not kept, so the next press tries again.
     */
    playerTemplate() {
      const inPlace = this.querySelector('template[data-story-player]');
      if (inPlace) return Promise.resolve(inPlace);

      if (!this.playerRequest) {
        const url = new URL(location.href);
        url.hash = '';
        url.searchParams.set('section_id', this.dataset.sectionId);

        this.playerRequest = fetch(url)
          .then((response) => {
            if (!response.ok) throw new Error(response.status);
            return response.text();
          })
          .then((html) => new DOMParser().parseFromString(html, 'text/html').querySelector('template[data-story-player]'))
          .catch(() => {
            this.playerRequest = null;
            return null;
          });
      }
      return this.playerRequest;
    }

    /*
     * Builds the player from its <template> the first time a story is opened, and wires it.
     * Everything below reads the player's own markup, so none of it can run before this.
     * Resolves false when the player could not be fetched.
     */
    async mount() {
      if (this.viewer) return true;
      const template = await this.playerTemplate();
      if (!template) return false;
      if (this.viewer) return true;
      this.append(template.content.cloneNode(true));
      template.remove();

      this.viewer = this.querySelector('[data-story-viewer]');
      this.slides = [...this.querySelectorAll('[data-story]')];
      this.panels = [...this.querySelectorAll('[data-story-panel]')];
      this.sound = this.querySelector('[data-story-sound]');
      this.count = this.querySelector('[data-story-count]');
      this.ticks = this.buildTicks();
      this.peeks = [...this.querySelectorAll('[data-story-peek]')];

      // Someone who asked for less motion gets the poster and the controls, not
      // a reel that starts on its own.
      if (this.quiet) {
        this.querySelectorAll('[data-story-video]').forEach((v) => v.setAttribute('controls', ''));
      }

      this.viewer.addEventListener('click', (event) => {
        if (event.target === this.viewer) this.requestClose();
      });

      this.viewer.addEventListener('pointerdown', (event) => this.swipeFrom(event));
      this.viewer.addEventListener('pointerup', (event) => this.swipeTo(event));
      this.viewer.addEventListener('pointercancel', () => (this.drag = null));

      // Arrow keys work wherever there is a keyboard, which is what keeps the
      // player steppable on a phone that has the buttons hidden.
      this.viewer.addEventListener('keydown', (event) => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        this.step(event.key === 'ArrowRight' ? 1 : -1);
      });

      // Escape closes through the same door, so it shrinks back to its cover
      // like every other way out.
      this.viewer.addEventListener('cancel', (event) => {
        if (this.closing) return;
        event.preventDefault();
        this.requestClose();
      });

      // Covers the close button, Escape and the backdrop in one place. The rail
      // keeps running behind the dim, as it does in the reference.
      this.viewer.addEventListener('close', () => {
        this.classList.remove('is-playing');
        this.viewer.style.opacity = '';
        this.pause();
        if (this.opener) this.opener.focus();
        this.opener = null;
        this.closing = false;
      });

      return true;
    }

    disconnectedCallback() {
      this.reelsNear?.disconnect();
      this.reelsSeen?.disconnect();
      this.reelAbort?.abort();
      if (this.railSize) this.railSize.disconnect();
    }

    /*
     * A mouse has no sideways swipe, so the steps beside the heading move the rail
     * a full row of covers at a time: the rail's width and one gap, which is exactly
     * where the next cover starts. They show only when the rail overflows, and go
     * quiet at either end -- aria-disabled rather than disabled, so a keyboard user
     * who steps to the end keeps their focus on the button.
     */
    watchRail() {
      const steps = this.closest('.stories')?.querySelector('[data-rail-steps]');
      const rail = this.querySelector('.stories__rail');
      if (!steps || !rail) return;
      const [back, more] = steps.querySelectorAll('[data-rail-step]');

      const sync = () => {
        const room = rail.scrollWidth - rail.clientWidth;
        const at = Math.abs(rail.scrollLeft);
        steps.hidden = room < 2;
        back.setAttribute('aria-disabled', String(at < 2));
        more.setAttribute('aria-disabled', String(at > room - 2));
      };

      steps.addEventListener('click', (event) => {
        const step = event.target.closest('[data-rail-step]');
        if (!step || step.getAttribute('aria-disabled') === 'true') return;
        const page = rail.clientWidth + (parseFloat(getComputedStyle(rail).columnGap) || 0);
        rail.scrollBy({
          left: Number(step.dataset.railStep) * page,
          behavior: this.quiet ? 'auto' : 'smooth',
        });
      });

      rail.addEventListener('scroll', sync, { passive: true });
      this.railSize = new ResizeObserver(sync);
      this.railSize.observe(rail);
    }

    onClick(event) {
      const cover = event.target.closest('[data-story-open]');
      if (cover) {
        // A second press while the player is still arriving is the same request.
        if (this.opening) return;
        this.opener = cover;
        this.open(Number(cover.dataset.storyOpen));
        return;
      }

      if (event.target.closest('[data-story-close]')) {
        this.requestClose();
        return;
      }

      if (event.target.closest('[data-story-sound]')) {
        this.toggleSound();
        return;
      }

      const stepper = event.target.closest('[data-story-step]');
      if (stepper) {
        this.step(Number(stepper.dataset.storyStep));
        return;
      }

      const pick = event.target.closest('[data-story-pick]');
      if (pick) {
        this.pickProduct(pick);
        return;
      }

      // A phone has no arrows: a tap on the reel's outer thirds steps, as stories
      // do everywhere else. A swipe fires no click, so nothing steps twice.
      const stage = event.target.closest('.stories__stage');
      if (stage && matchMedia('(max-width: 749px)').matches && !event.target.closest('a, button')) {
        const box = stage.getBoundingClientRect();
        const x = (event.clientX - box.left) / box.width;
        if (x > 2 / 3) this.step(1);
        else if (x < 1 / 3) this.step(-1);
      }
    }

    /*
     * One hairline per story along the top of the reel. It is the cue the phone
     * needs once the arrows are gone: it says how many there are and which one
     * this is, without a word of instruction. Built from the slides rather than
     * rendered a fourth time in Liquid, so the count cannot drift.
     */
    buildTicks() {
      const stage = this.querySelector('.stories__stage');
      if (!stage || this.slides.length < 2) return [];

      const row = document.createElement('div');
      row.className = 'stories__ticks';
      row.setAttribute('aria-hidden', 'true');

      const ticks = this.slides.map(() => {
        const tick = document.createElement('span');
        tick.className = 'stories__tick';
        row.append(tick);
        return tick;
      });

      stage.append(row);
      return ticks;
    }

    /*
     * Once a visit, the reel gives a small tug in the direction it travels. It
     * is the difference between a picture and something that moves, and it says
     * so without a label -- which is the only kind of instruction worth having.
     */
    hint() {
      if (this.quiet || this.slides.length < 2) return;
      if (!matchMedia('(max-width: 749px)').matches) return;

      try {
        if (sessionStorage.getItem('crystalicious:stories-hint')) return;
        sessionStorage.setItem('crystalicious:stories-hint', '1');
      } catch {
        // A private window has no memory to check. Hinting once per open there
        // is better than never hinting at all.
      }

      const slide = this.slides[this.current];
      if (!slide) return;

      slide.animate(
        [
          { transform: 'none' },
          { transform: 'translateX(-22px)' },
          { transform: 'none' },
        ],
        { duration: 880, delay: 720, easing: 'ease-in-out' }
      );
    }

    step(by) {
      const size = this.slides.length;
      if (size < 2) return;
      this.show((this.current + by + size) % size, false, by);
    }

    /*
     * On a phone the arrows are gone and this takes their place. Two circles
     * floating over a 390px reel was most of what was on the screen, and a swipe
     * is the gesture anyone opening a story already expects.
     *
     * Only on the reel: the panel beneath it is a scrolling box, and a drag
     * there belongs to the scroll.
     */
    swipeFrom(event) {
      const stage = event.target.closest('.stories__stage');
      this.drag = stage ? { x: event.clientX, y: event.clientY } : null;
    }

    swipeTo(event) {
      const from = this.drag;
      this.drag = null;
      if (!from) return;

      const across = event.clientX - from.x;
      const down = event.clientY - from.y;

      // A drag rather than a tap, and across the screen rather than up it.
      if (Math.abs(across) < 48 || Math.abs(across) < Math.abs(down)) return;

      this.step(across < 0 ? 1 : -1);
    }

    async open(index) {
      const cover = this.opener;
      this.opening = true;
      cover?.setAttribute('aria-busy', 'true');
      const ready = await this.mount();
      cover?.removeAttribute('aria-busy');
      this.opening = false;
      if (!ready) return;

      this.classList.add('is-playing');
      this.viewer.showModal();
      this.show(index, true);

      // The player takes focus, not the close button. Landing on a control
      // draws its focus ring, and on a phone the cross has no disc to hide one
      // -- a ring appeared around it every single time the player opened.
      this.viewer.focus();

      this.travel('in');
      this.hint();
    }

    /*
     * The player grows out of the cover that was pressed and shrinks back into
     * it, so the two are plainly the same object rather than a card and, after
     * a blink, an unrelated window.
     *
     * The transform sits on the view for the length of the animation only. It
     * is a containing block while it is there, which is why the close and the
     * arrows are children of the dialog and not of this.
     *
     * Only the reel moves. The chrome fades with the dialog, in CSS -- scripting
     * its opacity meant naming a value to end on, and a neighbour rests at 0.55,
     * not 1, so it landed bright and then snapped back.
     */
    travel(direction) {
      const view = this.viewer.querySelector('.stories__view');
      if (view) view.getAnimations().forEach((animation) => animation.cancel());

      const cover = this.opener;
      if (this.quiet || !cover || !view) return null;

      const from = cover.getBoundingClientRect();
      const to = view.getBoundingClientRect();
      if (!from.width || !to.width) return null;

      const shrunk =
        `translate(${from.left + from.width / 2 - (to.left + to.width / 2)}px, ` +
        `${from.top + from.height / 2 - (to.top + to.height / 2)}px) ` +
        `scale(${from.width / to.width})`;

      const entering = direction === 'in';

      /*
       * On the way out the reel only moves -- opacity is left to the dialog, so
       * the reel and the neighbours either side dim at one rate and leave
       * together. Fading it here as well made the middle disappear first and the
       * sides trail after it.
       */
      const frames = entering
        ? [
            { transform: shrunk, opacity: 0 },
            { transform: 'none', opacity: 1 },
          ]
        : [{ transform: 'none' }, { transform: shrunk }];

      return view.animate(frames, {
        duration: entering ? 520 : 320,
        easing: StoriesRail.EASE,
        fill: entering ? 'none' : 'forwards',
      });
    }

    requestClose() {
      if (this.closing) return;

      const shrinking = this.travel('out');
      if (!shrinking) {
        this.viewer.close();
        return;
      }

      // Fading now rather than on close(), so the chrome leaves with the reel.
      // Waiting for close() left the buttons hanging at full strength for a
      // moment after the reel had already gone.
      this.viewer.style.opacity = '0';

      this.closing = true;
      shrinking.finished.catch(() => {}).then(() => this.viewer.close());
    }

    /*
     * Watched stories live in this browser only (localStorage), as a story app's rings do. Storage
     * can be off or full -- a private window -- and then every ring simply stays blue.
     */
    seen() {
      try {
        return new Set(JSON.parse(localStorage.getItem(StoriesRail.SEEN)) || []);
      } catch {
        return new Set();
      }
    }

    markSeen(index) {
      const card = this.querySelectorAll('[data-story-id]')[index];
      if (!card) return;
      card.classList.add('is-seen');
      const seen = this.seen();
      if (seen.has(card.dataset.storyId)) return;
      seen.add(card.dataset.storyId);
      try {
        localStorage.setItem(StoriesRail.SEEN, JSON.stringify([...seen].slice(-60)));
      } catch {
        // Nowhere to keep it: the ring turns grey for this visit only.
      }
    }

    show(next, loud, by) {
      this.pause();

      // Read before it moves: the slide animation needs to know where it came
      // from, and `current` is about to become where it is going.
      const previous = this.current === next ? -1 : this.current;
      this.current = next;
      this.markSeen(next);

      const mark = (list, attr) =>
        list.forEach((el) => el.classList.toggle('is-active', Number(el.dataset[attr]) === next));

      mark(this.slides, 'story');
      mark(this.panels, 'storyPanel');
      this.ticks.forEach((tick, i) => tick.classList.toggle('is-active', i === next));

      if (!loud && !this.quiet && previous >= 0) this.slide(previous, next, by);

      if (this.count) this.count.textContent = `${next + 1} / ${this.slides.length}`;

      const size = this.slides.length;
      this.peeks.forEach((image) => {
        const offset = Number(image.dataset.storyPeek);
        const neighbour = this.slides[(next + offset + size) % size];
        if (!neighbour) return;

        image.src = neighbour.dataset.poster;
        const name = this.querySelector(`[data-story-peek-name="${offset}"]`);
        if (name) name.textContent = neighbour.dataset.name || '';
      });

      /*
       * Stepping fades the panel in behind the reel's own cross-fade. On the
       * first open the player is already growing, and two movements at once
       * read as a stutter.
       *
       * Opacity only, deliberately. A transform inside a scrolling box grows
       * that box's scrollable area, so lifting the panel 10px made its scroll
       * parent scrollable for the length of the animation -- a scrollbar
       * appearing and vanishing on every step.
       */
      if (!loud && !this.quiet) {
        const panel = this.panels.find((el) => el.classList.contains('is-active'));
        if (panel) {
          panel.animate([{ opacity: 0 }, { opacity: 1 }], {
            duration: 300,
            easing: StoriesRail.EASE,
          });
        }
      }

      this.warm(next);
      this.play(loud);
    }

    /*
     * One story leaves in the direction of travel while the next arrives from
     * the other side, and the neighbours nudge along with them, so stepping
     * reads as a run of stories moving rather than two pictures swapping.
     *
     * The slides live inside the stage, which clips. That matters: a transform
     * inside a box that scrolls would grow its scrollable area, which is what
     * put a flickering scrollbar on the panel earlier.
     */
    slide(from, to, by) {
      const size = this.slides.length;

      /*
       * The direction comes from whoever asked to move, not from working out
       * the shorter way round the ring. With two stories both ways round are
       * the same length, the tie always fell to forward, and going back looked
       * exactly like going on.
       */
      const forward = (to - from + size) % size;
      const step = by ? Math.sign(by) : forward <= (from - to + size) % size ? 1 : -1;
      const timing = { duration: 420, easing: StoriesRail.EASE };

      this.slides.forEach((el) => {
        el.getAnimations().forEach((animation) => animation.cancel());
        if (!el.classList.contains('is-active')) el.classList.remove('is-leaving');
      });

      const entering = this.slides[to];
      const leaving = this.slides[from];

      if (entering) {
        entering.animate(
          [
            { transform: `translateX(${step * 100}%)`, opacity: 0 },
            { transform: 'none', opacity: 1 },
          ],
          timing
        );
      }

      if (leaving) {
        leaving.classList.add('is-leaving');
        leaving
          .animate(
            [
              { transform: 'none', opacity: 1 },
              { transform: `translateX(${step * -100}%)`, opacity: 0 },
            ],
            timing
          )
          .finished.catch(() => {})
          .then(() => leaving.classList.remove('is-leaving'));
      }

      // Transform only. A neighbour rests at 0.55 opacity, and animating that
      // again is how it ended up flashing bright once already.
      this.peeks.forEach((image) => {
        const peek = image.closest('.stories__peek');
        if (!peek) return;
        peek.getAnimations().forEach((animation) => animation.cancel());
        peek.animate([{ transform: `translateX(${step * 22}px)` }, { transform: 'none' }], timing);
      });
    }

    videoIn(index) {
      return this.slides[index] ? this.slides[index].querySelector('[data-story-video]') : null;
    }

    /*
     * The story being watched and the one either side of it are given their
     * poster and told to load, so stepping shows a picture at once instead of a
     * blank stage and a spinner. Anything further away is left alone -- eight
     * reels loading because someone opened one is not a saving anywhere.
     */
    warm(index) {
      const size = this.slides.length;

      [0, 1, -1].forEach((offset) => {
        const slide = this.slides[(index + offset + size) % size];
        if (!slide) return;

        const video = slide.querySelector('[data-story-video]');
        if (!video) return;

        if (!video.getAttribute('poster')) video.setAttribute('poster', slide.dataset.poster);
        if (video.preload === 'none') video.preload = 'auto';
      });
    }

    play(loud) {
      const video = this.videoIn(this.current);
      if (this.sound) this.sound.hidden = !video;
      if (!video || this.quiet) return;

      video.preload = 'auto';
      // Opened by a press, so the sound is allowed to come with it.
      if (loud === true) video.muted = false;
      this.markSound(video);

      video.play().catch(() => {
        // Some browsers still refuse. Falling back to muted keeps the reel
        // playing rather than leaving a still frame and a dead control.
        video.muted = true;
        this.markSound(video);
        video.play().catch(() => {});
      });
    }

    pause() {
      this.querySelectorAll('[data-story-video]').forEach((video) => video.pause());
    }

    markSound(video) {
      if (!this.sound) return;
      this.sound.setAttribute('aria-pressed', String(!video.muted));
      this.sound.textContent = video.muted ? this.sound.dataset.off : this.sound.dataset.on;
    }

    toggleSound() {
      const video = this.videoIn(this.current);
      if (!video) return;
      video.muted = !video.muted;
      this.markSound(video);
    }

    pickProduct(pick) {
      const panel = pick.closest('[data-story-panel]');
      const wanted = pick.dataset.storyPick;

      panel.querySelectorAll('[data-story-product]').forEach((product) => {
        const on = product.dataset.storyProduct === wanted;
        product.classList.toggle('is-active', on);
        // Opacity only, for the same reason as the panel above: this sits
        // inside the panel's own scrolling box.
        if (on && !this.quiet) {
          product.animate([{ opacity: 0 }, { opacity: 1 }], {
            duration: 260,
            easing: StoriesRail.EASE,
          });
        }
      });

      panel.querySelectorAll('[data-story-pick]').forEach((button) => {
        const on = button === pick;
        button.classList.toggle('is-active', on);
        button.setAttribute('aria-current', String(on));
      });
    }

    add(event) {
      const form = event.target.closest('.stories__form');
      const button = form && form.querySelector('[data-story-add]');
      // Without the shared script (assets/cart-add.js) the form posts to the cart as normal.
      if (!button || !window.addToBag) return;
      event.preventDefault();
      window.addToBag(form, button, form.querySelector('[data-story-add-label]'));
    }
  }

  customElements.define('stories-rail', StoriesRail);

  } catch(e) { console.error(e); }
})();
})();
